import { FC, useState, useEffect } from 'react';
import {
  Box,
  Chip,
  SxProps,
} from '@mui/material';
import { useSearch, SEARCH_PARAM_COMMISSION } from '@carcareers/contexts';

interface JobSearchCommissionInputProps {
  sx?: SxProps;
}

export const JobSearchCommissionInput: FC<JobSearchCommissionInputProps> = ({ sx }) => {
  const { commission: commissionContext, updateSearchParams } = useSearch();
  
  const [includedCommission, setIncludedCommission] = useState<boolean>(
    commissionContext === 'true'
  );

  const handleCommissionToggle = () => {
    const newValue = !includedCommission;
    setIncludedCommission(newValue);
    updateSearchParams(SEARCH_PARAM_COMMISSION, newValue ? 'true' : undefined);
  };

  useEffect(() => {
    const isCommission = commissionContext === 'true';
    if (isCommission !== includedCommission) {
      setIncludedCommission(isCommission);
    }
  }, [commissionContext]);

  return (
    <Box sx={{ width: '100%', ...sx }}>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        <Chip
          label="Commission-based"
          onClick={handleCommissionToggle}
          color={includedCommission ? 'primary' : 'default'}
          variant={includedCommission ? 'filled' : 'outlined'}
          sx={{ mb: 1 }}
        />
      </Box>
    </Box>
  );
};

export default JobSearchCommissionInput;
